import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Survey = () => {
  const [formData, setFormData] = useState({
    challenges: "",
    additional_challenges: "",
    measurement_conducted: "",
    inefficiencies: "",
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

const handleSubmit = async (e) => {
    e.preventDefault();
    try {
        const response = await axios.post("https://restapi.hhcustomtailor.com/api/v1/save-survey/", formData, {
            headers: { "Content-Type": "application/json" }
        });

        // Success Message
        toast.success(
            <>
                Thank You! <br /><br /> Your form was submitted successfully. <br /> You will be redirected to our homepage in 3 seconds...
            </>,
            {
                position: "top-center",
                theme: "dark",
                autoClose: 3000
            }
        );

        // Redirect after 3 seconds
        setTimeout(() => navigate("/"), 3000);

    } catch (error) {
        console.error("Error:", error);

        // Error Handling
        toast.error("Submission failed! Please try again.", {
            position: "top-center",
            theme: "dark",
            autoClose: 3000
        });
    }
};

  return (
    <div className="survey-page">
      <div className="position-relative theme-bg">
        <div className="theme-color d-flex justify-content-center align-items-center padding-top-base padding-bottom-base">
          <div className="container">
            <img src="images/Meas-Sol_white.png" className="d-block mx-auto img-fluid" />
            <h1 className="text-center custom-font-md mb-4">Complete the survey to let us understand you better</h1>
            <div className="row justify-content-center">
              <div className="col-md-10 col-sm-12 col-12 padding-bottom-xl">
                <div className="p-5 form-bg shadow">
                    <div className="blur-background"></div>
                  <form onSubmit={handleSubmit} className="form-content">
                    <div className="mb-3">
                      <label className="form-label custom-font-base">
                          What seems to be the few main challenges your staff faces with their current uniforms?
                      </label>
                      <textarea className="form-control theme-color" 
                        name="challenges" rows="3"
                        value={formData.challenges}
                        onChange={handleChange}
                      ></textarea>
                    </div>

                    <div className="mb-3">
                      <label className="form-label custom-font-base">
                          Would you be able to list out some additional challenges from the management’s perspective related to staff uniforms on which you could offer some insights?
                      </label>
                      <textarea className="form-control theme-color"
                        name="additional_challenges" rows="3"
                        value={formData.additional_challenges}
                        onChange={handleChange}
                       ></textarea>
                    </div>

                    <div className="mb-3">
                      <label className="form-label custom-font-base">
                          How are measurements currently conducted to get a good fit or as close to a good fit as possible?
                      </label>
                      <textarea className="form-control theme-color"
                        name="measurement_conducted" rows="3"
                        value={formData.measurement_conducted}
                        onChange={handleChange}
                       ></textarea>
                    </div>

                    <div className="mb-3">
                      <label className="form-label custom-font-base">
                          Would you be able to help highlight or list out some of the main inefficiencies you are facing throughout the procuring process; and where would you place the measurements/sizing process and accuracy in terms of importance?
                      </label>
                      <textarea className="form-control theme-color"
                        name="inefficiencies" rows="3"
                        value={formData.inefficiencies}
                        onChange={handleChange}
                        ></textarea>
                    </div>
                    <button type="submit" className="btn btn-primary btn-no-bg d-block mx-auto theme-color fw-semibold font-md pt-5">
                        Submit
                    </button>
                    <span><ToastContainer /></span>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Survey;
